import React from 'react';
import { colors } from '@styleseat/brand';

type ArrowsChevronsBottomIconProps = {
  width?: number;
  height?: number;
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const ArrowsChevronsBottomIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
}: ArrowsChevronsBottomIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2928 5.29291L12 10.5858L6.70706 5.29291L5.29285 6.70712L12 13.4142L18.7071 6.70712L17.2928 5.29291ZM18.7071 11.7071L17.2928 10.2929L12 15.5858L6.70706 10.2929L5.29285 11.7071L12 18.4142L18.7071 11.7071Z"
      fill={color}
    />
  </svg>
);
